<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 font-weight-bold">Reportes - Ventas</h2>
        <div class="subtitle-2 grey--text">Listado de reportes disponibles para analisis de ventas.</div>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" md="6" lg="4">
        <v-card outlined hover class="report-card" @click="goToSalesSummaryReport">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-chart-timeline-variant</v-icon>
            Ventas por rango
          </v-card-title>
          <v-card-text>
            Resumen de ventas por dia, semana o mes con filtro opcional por vendedor.
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary">
              Abrir reporte
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card outlined hover class="report-card" @click="goToSalesTicketsReport">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-receipt-text-outline</v-icon>
            Ventas por ticket
          </v-card-title>
          <v-card-text>
            Lista tickets de venta por rango y vendedor, con detalle de productos vendidos.
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary">
              Abrir reporte
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card outlined hover class="report-card" @click="goToSalesProfitReport">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-cash-multiple</v-icon>
            Ganancias
          </v-card-title>
          <v-card-text>
            Resume venta, costo, ganancia y margen por dia, semana o mes.
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary">
              Abrir reporte
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <legacy-reports-group-cards group="sales" />
  </v-container>
</template>

<script>
import LegacyReportsGroupCards from '@/components/reports/LegacyReportsGroupCards.vue';

export default {
  name: 'ReportsSalesSectionView',
  components: { LegacyReportsGroupCards },
  methods: {
    goToSalesSummaryReport() {
      this.$router.push({ name: 'AdminReportSalesSummary' });
    },
    goToSalesTicketsReport() {
      this.$router.push({ name: 'AdminReportSalesTickets' });
    },
    goToSalesProfitReport() {
      this.$router.push({ name: 'AdminReportSalesProfit' });
    },
  },
};
</script>

<style scoped>
.report-card {
  cursor: pointer;
}
</style>
